import { AUSTRALIA_PHONE_CODE } from 'evee-ui-common/utils';
import { PhoneVerificationStatus } from 'evee-ui-common/enums';

export default {
  status: PhoneVerificationStatus.unverified,
  phoneNumber: {
    code: AUSTRALIA_PHONE_CODE,
    number: '',
  },
  verificationCode: '',
  loading: false,
  error: '',
};
